import React from "react";

import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import useClientIp from "core/utils/useClientIp";
import LoadingScreen from "core/components/LoadingScreen";
import { StreamPreviewQuery, StreamPreviewStatusQuery } from "player/queries";
import ErrorScreen from "core/components/ErrorScreen";
import PortableWifiOffIcon from "@mui/icons-material/PortableWifiOff";
import { useTranslation } from "react-i18next";
import PlayerPreview from "core/components/PlayerPreview";
import Video from "core/components/Video";
import PlayerFooter from "core/components/PlayerFooter";

const OFFLINE = "OFFLINE";

export default function Embed() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const getIpUrl = searchParams.get("getIpUrl");
  const { waitIp, clientIp } = useClientIp({ url: getIpUrl });
  const { t } = useTranslation("player");

  const { data, loading, error } = useQuery(StreamPreviewQuery, {
    variables: { token, clientIp },
    skip: waitIp,
    onCompleted: (data) => {
      if (data.streamPreview.status === "error") {
        window.location.href = data.streamPreview.playlist;
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });

  useQuery(StreamPreviewStatusQuery, {
    variables: { token },
    skip: waitIp,
    pollInterval: 5000,
  });

  const stream = data?.streamPreview;

  if (loading || waitIp) return <LoadingScreen />;

  if (error) return <ErrorScreen error={error} />;

  const img = stream?.thumbnails?.[stream?.thumbnails?.length - 1]?.url;

  if (stream) {
    if (stream?.status === OFFLINE) {
      return (
        <PlayerPreview overlay preview={img} id="preview">
          <ErrorScreen
            icon={PortableWifiOffIcon}
            title={t("noStream")}
            button={false}
          />
        </PlayerPreview>
      );
    }
  }

  return (
    <Video live muted autoPlay hlsUrl={stream.playlist} mediaId={stream.id}>
      {(videoElement, videoState, videoActions) => {
        return (
          <PlayerPreview preview={img} id="preview">
            {videoElement}
            <PlayerFooter
              position="absolute"
              visible
              videoElement={videoElement}
              videoState={videoState}
              videoActions={videoActions}
              hideShare
              hideLogo
              fullScreen={false}
            />
          </PlayerPreview>
        );
      }}
    </Video>
  );
}
